<style lang="scss">


    .box{

        a{font-size:12px;text-decoration: underline;color:#5078e6;}

        .recharge-form-box{
            margin: 10px;
            padding:0 150px ;
            .bankcard{width:160px;height:42px;border:1px solid #ddd}
            span.item{line-height: 40px;}
        }
        .tip-box{
            border-top:1px #d8d9df solid ;
            padding:20px 160px;
            p{
                font-size:12px;
                color:#333333;
                line-height:24px;
            }

        }



    }
    .pay-succ{
        text-align: center;
        img{
            width:402px;
            height:85px;
        }
        h4{
            font-size:24px;
            color:#48d2a0;
            margin:10px;
        }
        p{
            font-size:16px;
            color:#666666;
            line-height:30px;
        }
    }



</style>

<template>
    <div>
        <gf-page-title  :title="pageTitle" />
        <div class="box clearfix">
            <div class="recharge-form-box">
                <el-form  label-width="90px" ref="rechargeForm" :model="formData" :rules="rules" >
                    <el-form-item :label="pageTitle" >
                        <span class="item">{{payData.payAmount | currency}}元</span>
                    </el-form-item>
                    <el-form-item label="支付银行" >
                        <img class="bankcard" :src="`${baseUrl}miniBank/${payData.bankEnName.toUpperCase()}.png`" alt="">

                    </el-form-item>
                    <el-form-item label="支付银行卡" >
                        <span class="item">{{payData.bankAccountNo}}</span>
                    </el-form-item>
                    <el-form-item label="验证码" prop="sms">
                        <el-row>
                            <el-col :span="9"><el-input class="cus w120" v-model="formData.sms" @focus="doLog('PC支付流程-快捷支付-输入验证码')" placeholder="" ></el-input></el-col>
                            <el-col :span="6"><el-button @click="getCaptchaSms();doLog('PC支付流程-快捷支付-获取验证码')" :disabled="disableSmsBtn">{{disableSmsBtn? count+'秒后重发':'获取验证码'}}</el-button></el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-col :span="12">
                            <el-button size="medium" type="primary" :disabled="disableSubmitBtn" @click="submit">提交验证</el-button>
                        </el-col>
                    </el-form-item>

                </el-form>
            </div>
            <div class="tip-box">
                <p>
                    温馨提示 <br>
                    1.为了您能顺利完成支付，请使用在银行办理的一类账户进行支付<br>
                    2.借款用户充值的金额仅可用于还款<br>
                    3.所有账户可用金额将由第三方平台存管<br>
                    4.请注意您的网银支付上限<br>
                    5.如充值金额没有及时到账，请您联系客服：400-811-2288
                </p>
            </div>

        </div>

        <el-dialog
                title="存管信息提示"
                :visible.sync="dialogVisible"
                width="600px"
                :close-on-click-modal="false"
                :show-close="false"
                top="30vh"

        >
            <div class="pay-succ">
                <img src="../../assets/images/yrd_gf.jpg" alt="">
                <p>业务处理中，请稍后… <br>
                    请您不要关闭当前页面，等待业务处理结果
                </p>


            </div>


        </el-dialog>

    </div>
</template>
<script>
    import GfPageTitle from '../../components/gfPageTitle'
	export default {
		components:{GfPageTitle},

		data() {
		    return {
		    	pageTitleMap:{
					payMonthly:'按月还款',
					payAllLeft:'一次性结清',
					rechargeSubmit2:'账户充值',
                },
                pageTitle:'',
				dialogVisible:false,
		    	baseUrl:process.env.BASE_URL,
				disableSmsBtn:false,
				disableSubmitBtn:false,
                payData:{},
                currentBizId:'',
                queryTimes:0,
                count:60,
				formData:{
		    		sms:'',
                    password:''
                },
				rules:{
					sms:[
						{ required: true, message: '验证码不可为空', trigger: 'blur' },
						{ len: 6, message: '验证码格式错误', trigger: 'blur' },
					],

				}



			}
        },
		beforeRouteEnter (to, from, next) {
			next(vm => {
				vm.pageTitle=to.meta.title
			})
		},
        methods:{
			getLocalData(){
				const payId = this.$route.params.payId
				const data = window.localStorage.getItem(payId)
				this.payData = Object.assign({},this.payData,JSON.parse(data))

            },
			getCaptchaSms(){
				console.log(this.payData)
				this.count = 60;
				this.disableSmsBtn=true
				let timer = null
				this.$axios({
					method: 'post',
					url: '/repay2/quickPaySms',
					data:{payId:this.$route.params.payId}
				}).then( (res) =>{
					console.log(res)
					if(res.result){
						this.currentBizId = res.data.bizId
						clearInterval(timer)
						timer = setInterval(()=>{
							this.count--
							if(this.count===0){
								this.disableSmsBtn=false
								clearInterval(timer)

							}
						},1000)
					}else{
						this.disableSmsBtn=false
						this.$alert(res.berrormsg, '提示', {
							confirmButtonText: '确定',
						});
					}

				}).catch( (err)=> {
					this.disableSmsBtn=false
					console.warn(err)
				})

			},
            submit(){
				this.$refs['rechargeForm'].validate().then(()=>{
					this.disableSubmitBtn = true
					this.$axios({
						method: 'post',
						url: '/repay2/quickPaySubmit',
						data:{payId:this.$route.params.payId,bizId:this.currentBizId,verifyCode:this.formData.sms}
					}).then( (res) =>{
						console.log(res)
						this.disableSubmitBtn = false

						if(res.result){
                            this.dialogVisible = true
                            this.queryPayResult()

						}else{
							this.$alert(res.message, '提示', {
								confirmButtonText: '确定',
							});
						}

					}).catch( (err)=> {
						this.disableSubmitBtn = false
						console.warn(err)
					})
				})
            },
			queryPayResult(){
				let payId = this.$route.params.payId
                console.log('payId',payId)
				this.$axios({
					method: 'post',
					url: '/repay2/queryPayResult',
					data:{payId}
				}).then( (res) =>{
					console.log(res)
					if(res.result){
						if(res.data.status == 'DEALING' ||res.data.status == 'UNPAY'){
							this.queryPayResult()

						}
						if(res.data.status == 'OK'){
							//如果是充值
                            if(this.$route.name == 'rechargeSubmit2'){
								const payData ={status:true,rechargeAmount:this.payData.payAmount}

								localStorage.setItem(payId,JSON.stringify(payData))
								this.$router.push({name:'rechargeResult2', params: { payId }})
								_hmt.push(['_trackEvent', '充值成功事件', '账户首页-去充值-充值成功']);
								this.doLog('账户首页-充值-充值成功')
                            }else{
                            	//还款
								this.$router.push({name:'payStatus', query: { state:'02' }})
								this.doLog('PC我的借款-我的还款-还款结果-还款成功')

							}

						}
						if(res.data.status == 'FAIL'){
							//  去新还款失败页
							if(this.$route.name == 'rechargeSubmit2'){
								this.$router.push({name:'rechargeResult2', params: { payId }})
                                this.doLog('账户首页-充值-充值失败')
							}else{
								this.$router.push({name:'payStatus', query: { state:'03' }})
								this.doLog('PC我的借款-我的还款-还款结果-还款失败-'+res.data.desc)

							}
						}

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});

					}

				}).catch(function (err) {
					console.warn(err)
				})
            }



        },
        created(){
			this.getLocalData()
        }
    }
</script>
